/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import Heading from "components/Heading";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ROUTES from "routes";
import { Button } from "components/Button";
import WarningTriangleIcon from "assets/Icons/WarningTriangleIcon";
import LOCAL_STORAGE_KEYS from "constants/STORAGE_KEYS";
import { useGlobal } from "state/GeneralContext";

function hasStoredSession(): boolean {
  try {
    const storage = globalThis.localStorage;
    if (storage === undefined) {
      return false;
    }
    const token = storage.getItem(LOCAL_STORAGE_KEYS.token);
    const id = storage.getItem(LOCAL_STORAGE_KEYS.id);
    return !!token && !!id;
  } catch {
    return false;
  }
}

const PageNoAccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { events } = useGlobal();
  const hasSession = hasStoredSession();
  const hasMultipleEvents = events.length > 1;
  const showSwitchEvents = hasSession && hasMultipleEvents;

  const handleAction = () => {
    if (hasSession) {
      navigate(ROUTES.eventSwitcher, { replace: true });
    } else {
      navigate(ROUTES.login, { replace: true });
    }
  };

  return (
    <main className="min-h-screen min-w-full flex flex-col items-center justify-center -bg--theme-colors-surface-neutral-level00 text-center px-s20">
      <WarningTriangleIcon className="flex-shrink-0 mb-s40" />
      <Heading
        as="h1"
        className="text-2xl font-bold -text--theme-colors-text-title mb-1"
      >
        {t("errors.noAccessTitle")}
      </Heading>
      <p className="text-sm font-semibold -text--theme-colors-text-body mb-8">
        {t("errors.noAccessMessage")}
      </p>
      <Button
        variant="primary"
        size="lg"
        as="button"
        onClick={handleAction}
        className="px-16"
      >
        {showSwitchEvents ? t("errors.switchEvents") : t("errors.goBack")}
      </Button>
    </main>
  );
};

export default PageNoAccess;
